import { DashboardStats } from '../../domain/entities/DashboardStats';
import { ScheduleEvent } from '../../domain/entities/ScheduleEvent';
import { Notification } from '../../domain/entities/Notification';
import { DashboardStatsDTO } from '../dto/DashboardStatsDTO';
import { ScheduleEventDTO } from '../dto/ScheduleEventDTO';
import { NotificationDTO } from '../dto/NotificationDTO';

/**
 * Dashboard Mapper
 * Converts between Dashboard entities and DTOs
 */
export class DashboardMapper {
  static statsToDTO(stats: DashboardStats): DashboardStatsDTO {
    return {
      stat1: stats.stat1,
      stat2: stats.stat2,
      stat3: stats.stat3,
    };
  }

  static statsToDomain(dto: DashboardStatsDTO): DashboardStats {
    return new DashboardStats({
      stat1: dto.stat1,
      stat2: dto.stat2,
      stat3: dto.stat3,
    });
  }

  static scheduleEventToDTO(event: ScheduleEvent): ScheduleEventDTO {
    return {
      id: event.id,
      title: event.title,
      time: event.time,
      color: event.color,
    };
  }

  static scheduleEventToDomain(dto: ScheduleEventDTO): ScheduleEvent {
    return new ScheduleEvent({
      id: dto.id,
      title: dto.title,
      time: dto.time,
      color: dto.color,
    });
  }

  static scheduleEventToDTOList(events: ScheduleEvent[]): ScheduleEventDTO[] {
    return events.map((event) => this.scheduleEventToDTO(event));
  }

  static scheduleEventToDomainList(dtos: ScheduleEventDTO[]): ScheduleEvent[] {
    return dtos.map((dto) => this.scheduleEventToDomain(dto));
  }

  static notificationToDTO(notification: Notification): NotificationDTO {
    return {
      id: notification.id,
      message: notification.message,
      time: notification.time,
      isRead: notification.isRead,
      readAt: notification.readAt,
      scopeType: notification.scopeType,
    };
  }

  static notificationToDomain(dto: NotificationDTO): Notification {
    return new Notification({
      id: dto.id,
      message: dto.message,
      time: dto.time,
      isRead: dto.isRead,
      readAt: dto.readAt,
      scopeType: dto.scopeType,
    });
  }

  static notificationToDTOList(notifications: Notification[]): NotificationDTO[] {
    return notifications.map((notification) => this.notificationToDTO(notification));
  }

  static notificationToDomainList(dtos: NotificationDTO[]): Notification[] {
    return dtos.map((dto) => this.notificationToDomain(dto));
  }
}
